/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { gridMenuDataSource } from '~/pages/Menu/MenuServices';
import { addMenuID } from '~/store/modules/Menu/actions';
import { Container } from './styles';

function Lista({ loading }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  return (
    <Container>
      <section>
        <div className="sec1">
          <h1>Menus</h1>
        </div>
        <div className="add">
          <Link to="/menu/register" className="link">
            <FaPlus />
          </Link>
        </div>
      </section>

      {loading ? (
        <Spinner
          color="dark"
          style={{ height: '3rem', width: '3rem', margin: '5% 400px' }}
        />
      ) : (
        <DataGrid
          dataSource={gridMenuDataSource}
          remoteOperations
          showBorders
          allowColumnReordering
          allowColumnResizing={false}
          columnAutoWidth={false}
          onOptionChanged={handleOptionChange}
        >
          <Editing mode="row" useIcons allowDeleting />
          <Pager
            visible
            showPageSizeSelector
            allowedPageSizes={[7, 10, 15]}
            showInfo
          />
          <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
          <FilterRow
            visible={filterOptions.showFilterRow}
            applyFilter={filterOptions.currentFilter}
          />
          <Column
            dataField="id"
            caption="ID menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="nome"
            caption="Nome Menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="descricao"
            caption="Descricao Menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="tipoPagina"
            caption="Tipo Pagina"
            filterOperations={false}
            alignment="left"
            allowFiltering={false}
            cellRender={(e) =>
              e.row.data.tipoPagina === 'M' ? 'Menu' : 'Opção'
            }
          />
          <Column
            dataField="url"
            caption="Rota"
            filterOperations={false}
            allowFiltering={false}
            alignment="left"
          />
          <Column type="buttons" caption="Sub Menus" width={100}>
            <Button
              hint="Sub menus"
              visible
              icon="alignjustify"
              onClick={(e) => {
                dispatch(addMenuID(e.row.data.id));
                history.push(`/menu/menu-sub/${e.row.data.id}`);
              }}
            />
          </Column>
          <Column type="buttons" caption="Ações" width={100}>
            <Button
              hint="Editar"
              visible
              icon="edit"
              onClick={(e) => history.push(`/menu/update/${e.row.data.id}`)}
            />
            <Button name="delete" visible hint="Deletar" icon="trash" />
          </Column>
        </DataGrid>
      )}
    </Container>
  );
}

export default Lista;
